import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Form } from "react-bootstrap";
import SelectInput, { SelectOption } from "./SelectInput";

interface RHFSelectInputProps {
  options: SelectOption[];
  label: string;
  isRequired?: boolean;
  placeholder?: string;
  noOptionsMessage?: () => string;
  disabled?: boolean;
  /** Bootstrap group props */
  groupProps: React.ComponentProps<typeof Form.Group>;
  labelProps?: React.ComponentProps<typeof Form.Label>;
  onCreateOption?: (newOption: SelectOption) => void;
}

const RHFSelectInput: React.FC<RHFSelectInputProps> = ({
  options,
  label,
  isRequired = false,
  placeholder,
  noOptionsMessage,
  groupProps,
  labelProps = {},
  disabled = false,
  onCreateOption,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const name = groupProps.controlId;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <SelectInput
            label={label}
            isRequired={isRequired}
            options={options}
            value={options.find((o) => o.value === field.value) ?? null}
            onChange={(option) => {
              field.onChange(option.value);
            }}
            error={errors?.[name]?.message as string}
            groupProps={groupProps}
            labelProps={labelProps}
            placeholder={placeholder}
            noOptionsMessage={noOptionsMessage}
            isDisabled={disabled}
            onCreateOption={(newOption) => {
              onCreateOption?.(newOption);

              field.onChange(newOption.value);
            }}
          />
        );
      }}
    />
  );
};

export default RHFSelectInput;
